import { TREND_STATUS } from '../../constants';

/** Возвращает текущий статус тренда для изменения цены актива */
export const getTrendStatus = (pricePercent?: number | null) => {
    if (typeof pricePercent === 'number') {
        if (pricePercent > 0) {
            return TREND_STATUS.positive;
        }
        if (pricePercent < 0) {
            return TREND_STATUS.negative;
        }
        if (pricePercent === 0) {
            return TREND_STATUS.neutral;
        }
    }

    return TREND_STATUS.empty;
};
